export default __webpack_public_path__ + "static/media/1.f23d4b31.jpg";